import { createComponent } from '@mtfe/sweet';
import { lazyLoadImg } from '@mtfe/sweet-utils'
import tpl from './dom.html';
import style from './style.less';

const { DEFAULT_DATA_SRC } = lazyLoadImg;

const PoiInfoBase = (props) => {
    const {
        poiInfo,
        isLazyLoadImg,
        onPoiInfoClick,
        itemIndex = -1,
    } = props || {};

    let ugc = '';
    const poi_label_map_10 =
        poiInfo.poiBaseInfo.poi_label_map && poiInfo.poiBaseInfo.poi_label_map['10'];
    if (poi_label_map_10 && poi_label_map_10[0]) {
        ugc = (poi_label_map_10[0].content || '').replace(/^“+|”+$/gm, '');
        if (ugc.length > 15) {
            ugc = ugc.substring(0, 15) + '...';
        }
    }
    const data = {
        itemIndex,
        DEFAULT_DATA_SRC,
        poiInfo,
        isLazyLoadImg,
        ugc,
        shopLabelIcon:
            (poiInfo.poiBaseInfo &&
                poiInfo.poiBaseInfo.poi_label_map &&
                poiInfo.poiBaseInfo.poi_label_map['3'] &&
                poiInfo.poiBaseInfo.poi_label_map['3'][0]['label_icon']) ||
            '',
    };
    const events = {
        onPoiInfoClick: () => {
            if (onPoiInfoClick) {
                onPoiInfoClick(poiInfo);
                return false;
            }
        },
    };
    const component = createComponent(tpl, { data, style }, events);

    return component;
};

export default PoiInfoBase;
